import { useEffect } from 'react';

/**
 * A custom hook that updates the document title
 * 
 * @param title The title to set for the page
 * @param suffix An optional suffix to append to the title (e.g., site name)
 */
export function useTitle(title: string, suffix: string = '| Prompted Forge') {
  useEffect(() => {
    // Update the document title when the component mounts
    const previousTitle = document.title;
    document.title = `${title} ${suffix}`;

    // Restore the previous title when the component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
}